export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_ADD_NEW_EXPERIENCE = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_ADD_NEW_EXPERIENCE'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_START_EDITING = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_START_EDITING'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_STOP_EDITING = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_STOP_EDITING'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_EDITING = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_EDITING'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_MONTH = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_MONTH'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_YEAR = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_YEAR'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_MONTH = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_MONTH'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_YEAR = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_YEAR'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_END_DATE_CURRENT = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_END_DATE_CURRENT'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE_MODAL = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE_MODAL'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETING_EXPERIENCE = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETING_EXPERIENCE'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETED_EXPERIENCE = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETED_EXPERIENCE'
export const PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_DELETING_EXPERIENCE = 'PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_DELETING_EXPERIENCE'

export const setAddNewWorkExperience = () => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_ADD_NEW_EXPERIENCE,
  experience: {
    position: null,
    company: null,
    isCurrentJob: false,
    positionStartDate: null,
    positionEndDate: null
  }
})

export const setStartEditingWorkExperience = (index) => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_START_EDITING,
  index
})

export const setStopEditingWorkExperience = () => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_STOP_EDITING
})

export const setCancelEditingWorkExperience = () => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_EDITING
})

export const setWorkExperience = (validationResult, experience) => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE,
  experience,
  validationResult
})

export const setWorkExperiencePositionStartMonth = (validationResult, month) => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_MONTH,
  month,
  validationResult
})

export const setWorkExperiencePositionStartYear = (validationResult, year) => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_YEAR,
  year,
  validationResult
})

export const setWorkExperiencePositionEndMonth = (validationResult, month) => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_MONTH,
  month,
  validationResult
})

export const setWorkExperiencePositionEndYear = (validationResult, year) => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_YEAR,
  year,
  validationResult
})

export const setWorkExperiencePositionEndDateCurrent = () => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_END_DATE_CURRENT
})

export const setDeleteWorkExperienceModal = (index) => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE_MODAL,
  index
})

export const setDeleteWorkExperience = () => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE
})

export const setDeletingWorkExperience = () => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETING_EXPERIENCE
})

export const setDeletedWorkExperience = () => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETED_EXPERIENCE
})

export const setCancelDeletingWorkExperience = () => ({
  type: PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_DELETING_EXPERIENCE
})

export const deleteWorkExperience = () => {
  return (dispatch) => {
    dispatch(setDeleteWorkExperience())
    dispatch(setDeletingWorkExperience())
  }
}
